import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { PILL_BUTTON } from '../ui-chrome';

interface NudgesEmptyStateProps {
	onCreate: () => void;
}

/** No nudges yet: say what one is and offer to make the first. */
export const NudgesEmptyState = ({ onCreate }: NudgesEmptyStateProps) => (
	<div className='flex flex-col items-center gap-1.5 px-4 py-16 text-center'>
		<p className='text-sm text-ink'>No nudges yet</p>
		<p className='max-w-md text-[13px] text-gray-800'>
			A nudge is a short chat prompt Kim shows a shopper at the right moment, like when their cart has sat
			idle or they are about to leave.
		</p>
		<Button type='button' onClick={onCreate} className={cn(PILL_BUTTON, 'mt-3 gap-2')}>
			<Plus className='size-3.5' /> Create Nudge
		</Button>
	</div>
);
